import type {ReactElement, ReactNode} from 'react';

type LimitStatusNoteProps = {
  /** Whether the server checks this limit on transactions today. */
  inUse: boolean;
  children: ReactNode;
};

/**
 * Says what a limit is for and whether it is enforced, so whoever sets one
 * knows if it will stop a transaction.
 */
const LimitStatusNote = ({
  inUse,
  children,
}: LimitStatusNoteProps): ReactElement => (
  <p className="text-sm text-gray-600 dark:text-gray-300 mb-4 max-w-3xl">
    <span
      className={`mr-2 text-xs font-medium px-2 py-0.5 rounded ${
        inUse
          ? 'bg-green-100 text-green-700 dark:bg-green-900/40 dark:text-green-200'
          : 'bg-gray-200 text-gray-700 dark:bg-gray-800 dark:text-gray-200'
      }`}
    >
      {inUse ? 'In use' : 'Not in use'}
    </span>
    {children}
  </p>
);

export default LimitStatusNote;
